{
    "SortAsc1Label": "1ª ascendente",
    "SortDsc1Label": "1a discesa",
    "SortAsc2Label": "2° ascendente",
    "SortDsc2Label": "2a discesa",
    "SortAsc3Label": "3° ascendente",
    "SortDsc3Label": "3° Discendente",
    "SortNoneLabel": "[Non ordinati per]",
    "SortAsc1Tooltip": "Ordina principalmente le righe del rapporto in modo ascendente in base alla statistica\/campo selezionato.",
    "SortDsc1Tooltip": "Ordina principalmente le righe del rapporto in modo decrescente in base alla statistica\/campo selezionato.",
    "SortAsc2Tooltip": "Ordinamento secondario ascendente in base alla statistica\/campo selezionato.",
    "SortDsc2Tooltip": "Ordinamento secondario decrescente in base alla statistica\/campo selezionato.",
    "SortAsc3Tooltip": "Ordina le righe del rapporto al terzo posto in ordine crescente in base alla statistica\/al campo selezionato.",
    "SortDsc3Tooltip": "Ordina le righe del rapporto in terza posizione decrescente in base alla statistica\/campo selezionato.",
    "SortNoneTooltip": "Non ordinare le righe del report in base alla statistica\/campo selezionato.",
    "NAME": "SortList"
}